/*
 *
 */

import { Box, Checkbox, Collapse, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import React, { Fragment } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { useAppStore } from '../../../store/appStore.tsx';
import { useNavigate } from 'react-router-dom';


const ReadOnlyRow = ({ row, usuario, currentUser, setOpenDialog, setOpenAddEditDialog, setIsUpdate, setDeleteRow, selectedRow, setSelectedRow }) => {

    const [open, setOpen] = React.useState(false);
    const { setDevice } = useAppStore(appStore => appStore);
    const { setDeviceUser } = useAppStore(appStore => appStore);

    const navigate = useNavigate();

    //console.log("usuario: ", usuario);
    //console.log("row: ", row);

    const handleReportesClick = (event, row) => {
        event.preventDefault();
        //console.log('handelSettingsClick row: ', row);
        setDevice(row);
        setDeviceUser(usuario);
        navigate('/reportes/estado');
    }

    const handleSettingsClick = (event, row) => {
        event.preventDefault();
        //console.log('handelSettingsClick row: ', row);
        setDevice(row);
        navigate('/gestion/config/alarma');
        //setIsUpdate(true);
        //setAddEditRow(row);
        //setOpenAddEditDialog(true);    //Abre el dialogo para nuevo/editar proveedor
    }

    const handleDeleteClick = (event, row) => {
        event.preventDefault();
        //setEditRowId(null);
        setDeleteRow(row);
        setOpenDialog(true);
    }

    const handleEditClick = (event, row) => {
        event.preventDefault();
        //console.log('handelEditClick row: ', row);
        setIsUpdate(true);
        //setAddEditRow(row);
        setOpenAddEditDialog(true);    //Abre el dialogo para nuevo/editar proveedor
    }

    const handleRowClick = (event) => {

        //console.log(row.id, event.detail);
        switch (event.detail) {
            case 1: {
                //console.log('single click');
                setSelectedRow(row);
                //setRowOriginal(row);
                break;
            }
            case 2: {
                //console.log('double click');
                setSelectedRow(row);
                setIsUpdate(true);
                setOpenAddEditDialog(true);    //Abre el dialogo para nuevo/editar proveedor
                break;
            }
            default: {
                break;
            }
        }
    }

    return (
        <Fragment>
            <TableRow key={row.id} onClick={handleRowClick}
                sx={{
                    '& > *': { color: row.enF ? 'black' : 'lightgray' },
                    backgroundColor: selectedRow?.id === row.id ? '#F0F0F0' : 'white',
                    color: row.enF ? 'black' : 'lightgray',
                    textDecoration: row.enF ? 'none' : 'line-through',
                }}>

                <TableCell >
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>

                <TableCell key={row.id + '_id'} align='left'>
                    <Box sx={{ maxwidth: '50px', border: 0 }}>
                        {row.id}
                    </Box>
                </TableCell>
                <TableCell key={row.id + '_en'} align='left'>
                    <Box sx={{ maxwidth: '60px', border: 0 }}>
                        <Checkbox disabled checked={row.enF ? true : false} />
                    </Box>
                </TableCell>
                <TableCell key={row.id + '_devid'} align='left'>
                    <Box sx={{ width: '90px', border: 0 }}>
                        {row.devId} (0x{row.devId.toString(16).toUpperCase().padStart(2, '0')})
                    </Box>
                </TableCell>
                <TableCell key={row.id + '_nser'} align='center'>
                    <Box sx={{ width: '70px', border: 0 }}>
                        {row.numSerial} (0x{row.numSerial.toString(16).toUpperCase().padStart(4, '0')})
                    </Box>
                </TableCell>
                <TableCell key={row.id + '_desc'} align='left'>
                    <Box sx={{ width: '200px', border: 0 }}>
                        {row.descripcion}
                    </Box>
                </TableCell>
                {/*<TableCell key={row.id + '_hv'} align='left'>
                    <Box sx={{ width: '70px', border: 1 }}>
                        {row.hwVer}
                    </Box>
                </TableCell>
                <TableCell key={row.id + '_mac'} align='left'>
                    <Box sx={{ width: '110px', border: 1 }}>
                        {row.macAdd}
                    </Box>
                </TableCell>
                <TableCell key={row.id + '_imei'} align='left'>
                    <Box sx={{ width: '130px', border: 1 }}>
                        {row.imei}
                    </Box>
                </TableCell>*/}
                <TableCell key={row.id + '_cel'} align='left'>
                    <Box sx={{ width: '120px', border: 0 }}>
                        {row.devCel}
                    </Box>
                </TableCell>
                {/*<TableCell key={row.id + '_user'} align='left'>
                    <Box sx={{ width: '200px', border: 0 }}>
                        {row.devUserName}
                </Box>
                </TableCell>*/}
                <TableCell key={'controles_' + row.id} align='left'>
                    <Stack direction='row' spacing={0}>
                        <IconButton color="primary" aria-label="rep" onClick={(event) => handleReportesClick(event, row)}>
                            <SummarizeIcon fontSize="small" />
                        </IconButton>
                        {(currentUser?.tipoUsuario === 'superusuario' || currentUser?.tipoUsuario === 'administrador') &&
                            <>
                                <IconButton color="primary" aria-label="conf" onClick={(event) => handleSettingsClick(event, row)}>
                                    <SettingsIcon fontSize="small" />
                                </IconButton>
                                <IconButton color="primary" aria-label="edit" onClick={(event) => handleEditClick(event, row)}>
                                    <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton sx={{ color: 'red' }} aria-label="del" onClick={(event) => handleDeleteClick(event, row)}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </>
                        }
                    </Stack>
                </TableCell>
            </TableRow>



            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
                    <Collapse in={open} timeout="auto" unmountOnExit>

                        <Box fullwidth='true' sx={{ margin: 2, paddingBottom: 3, bgcolor: '#F7F7F7' }}>
                            <Typography variant="h6" gutterBottom component="div">
                                Datos adicionales
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">Dispositivo</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell colSpan={2} align="center">Usuario Administrador</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell align="center">Comentarios</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Ver HW</TableCell>
                                        <TableCell>Ver SW</TableCell>
                                        <TableCell>MacAdd</TableCell>
                                        <TableCell align="left">IMEI</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell>Nombre</TableCell>
                                        <TableCell align="left">Celular</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell >{row.hwVer} (0x{row.hwVer.toString(16).toUpperCase().padStart(2, '0')})</TableCell>
                                        <TableCell >{row.swVer} (0x{row.swVer.toString(16).toUpperCase().padStart(2, '0')})</TableCell>
                                        <TableCell>{row.macAdd}</TableCell>
                                        <TableCell align="left">{row.imei}</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell>{row?.devUserName || "---"}</TableCell>
                                        <TableCell align="left">{row?.devUserCel || "---"}</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell>
                                            <Box sx={{ width: '240px', border: 0 }}>
                                                {row.comments}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>

                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>

    )
}

export default ReadOnlyRow